export default "__VITE_ASSET__bfqJ97jo__"